// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"264":"022689b8347b78c0","955":"6485be42865e0c34"}[chunkId] + ".css";
};